"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinInput = void 0;
var React = _interopRequireWildcard(require("react"));
var _InputField = require("../InputField");
var _keyCodes = require("../../types/keyCodes");
var styles = _interopRequireWildcard(require("./PinInput.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PinInput = _ref => {
  let {
    value,
    disabled,
    invalid,
    length,
    onChange,
    onSubmit,
    onCompletedChange
  } = _ref;
  const elements = React.useMemo(() => [], []);
  const normalizedValue = React.useMemo(() => Array.from({
    length
  }, (_, index) => value[index] || ''), [length, value]);
  const currentPinLength = React.useMemo(() => normalizedValue.filter(chunk => chunk.length > 0).length, [normalizedValue]);
  const isPinCompleted = currentPinLength === length;
  React.useEffect(() => {
    if (currentPinLength !== 0) {
      return;
    }
    const firstElement = elements[0];
    if (firstElement) {
      firstElement.focus();
    }
  }, [currentPinLength, elements]);
  React.useEffect(() => {
    if (!onCompletedChange) {
      return;
    }
    onCompletedChange(isPinCompleted);
    /**
     * Убрал из зависимостей onCompletedChange, поскольку он провоцирует повторную отправку
     * запроса register-or-authorize-user во frontend-mobile-website.
     */
  }, [isPinCompleted]);
  const handleInputChange = (e, index) => {
    const targetValue = e.currentTarget.value;
    const nextValue = [...normalizedValue];
    const nextElement = elements[index + 1];
    nextValue[index] = targetValue;
    onChange(nextValue);
    if (targetValue.length > 0 && nextElement) {
      nextElement.focus();
    }
  };
  const handleKeyDown = (e, index) => {
    const value = normalizedValue[index];
    if (e.keyCode === _keyCodes.EKeyCode.Backspace && !value) {
      const previousElement = elements[index - 1];
      if (previousElement) {
        previousElement.focus();
      }
      return;
    }
    if (e.keyCode === _keyCodes.EKeyCode.Enter && isPinCompleted) {
      onSubmit();
      return;
    }
  };
  const handleFocus = React.useCallback(e => {
    e.target.select();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, normalizedValue.map((inputValue, index) => /*#__PURE__*/React.createElement(_InputField.InputField, {
    value: inputValue,
    ref: r => elements[index] = r,
    key: `pin_input_${index}`,
    name: `pin_input_${index}`,
    type: "tel",
    fieldType: "pin",
    invalid: invalid,
    disabled: disabled,
    onFocus: handleFocus,
    onKeyDown: e => handleKeyDown(e, index),
    onChange: e => handleInputChange(e, index)
  })));
};
exports.PinInput = PinInput;
PinInput.displayName = 'PinInput';